import type {
  PayOverTimeAgreement,
  PayOverTimePaymentPlanDetails,
  SubmitPayOverTimeOnboardingPaymentPlan,
} from '@varo/graphql-schema-types';
import { atom } from 'jotai';

export const transactionIdAtom = atom<string>('');

export const paymentPlanDetailsAtom =
  atom<PayOverTimePaymentPlanDetails | null>(null);

export const registrationInfoIdAtom = atom<string>('');

export const agreementIdAtom = atom<string>('');

export const agreementAtom = atom<PayOverTimeAgreement | null>(null);

export const setPayOverTimePaymentPlanStateAtom = atom(
  null,
  (_get, set, paymentPlan: SubmitPayOverTimeOnboardingPaymentPlan): void => {
    set(paymentPlanDetailsAtom, paymentPlan.paymentPlanDetails);
    set(registrationInfoIdAtom, paymentPlan.registrationInfoId);
    set(agreementIdAtom, paymentPlan.agreementId);
    set(agreementAtom, paymentPlan.agreement);
  },
);
